import { darkTheme } from "naive-ui";
import { ref } from "vue-demi";
import { darkThemeOverrides, lightThemeOverride } from "./theme-overrides";

const isDark = ref(true);
const darkT = ref(darkTheme as any);
const themeOverride = ref(darkThemeOverrides as any);

// if (localStorage.getItem('colorMode') === 'dark' || (!localStorage.getItem('colorMode') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//   localStorage.setItem('colorMode', 'dark');
//   isDark.value = true;
//   darkT.value = darkTheme;
//   themeOverride.value = darkThemeOverrides;
// } else {
//   localStorage.setItem('colorMode', 'light');
//   isDark.value = false;
//   darkT.value = null;
//   themeOverride.value = lightThemeOverride;
// }

// const toggleDark = () => {
//   isDark.value = !isDark.value;
//   darkT.value = isDark.value ? darkTheme : null;
//   themeOverride.value = isDark.value ? darkThemeOverrides : lightThemeOverride;
//   localStorage.setItem('colorMode', isDark.value ? 'dark' : 'light');
//   document.documentElement.style.setProperty('--body-background', isDark.value ? '#000' : '#fff');
// };

document.documentElement.style.setProperty('--body-background', isDark.value ? '#000' : '#fff');

export {
  darkT,
  // toggleDark,
  themeOverride
}
